var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1481 14H2.85185C2.06433 14 1.42593 13.3732 1.42593 12.6V3.5H0V2.1H2.85185V1.4C2.85185 0.626801 3.49026 0 4.27778 0H9.72222C10.5097 0 11.1481 0.626801 11.1481 1.4V2.1H14V3.5H12.5741V12.6C12.5741 13.3732 11.9357 14 11.1481 14ZM2.85185 3.5V12.6H11.1481V3.5H2.85185ZM4.27778 1.4V2.1H9.72222V1.4H4.27778ZM9.00926 11.2H7.58333V4.9H9.00926V11.2ZM6.41667 11.2H4.99074V4.9H6.41667V11.2Z",
    fill: "#E31B28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.601690aaac51255c92d624ab141d77be.svg";
export { ForwardRef as ReactComponent };